<script>
	import { PUBLIC_PATH } from '$env/static/public';
	import { footerData } from '$lib/constants/footer';
</script>

<footer class="bg-black-title">
	<div class="mx-auto max-w-8xl px-padding_lg py-8 lg:px-[8.625rem] lg:py-0">
		<!-- Logo Section -->
		<div class="pb-padding_xxlg lg:pt-space_40">
			<img
				class="h-8 w-auto lg:h-space_40"
				src={`${PUBLIC_PATH}/${footerData.logo}`}
				alt="Angel Fincap"
			/>
		</div>

		<!-- Top Divider -->
		<div class="h-px w-full bg-[#38485f]"></div>

		<!-- Desktop: 3-column horizontal layout -->
		<div class="hidden lg:flex items-start gap-[1.875rem] py-8">
			<!-- Column 1: Company Info (flex-1) -->
			<div class="flex-1 text-white">
				<p class="font-barlow text-xl font-semibold leading-[1.4]">
					{footerData.companyInfo.title}
				</p>
				<div
					class="mt-[0.8125rem] font-barlow text-h6_light capitalize text-white"
					style="line-height: 2.322;"
				>
					{#each footerData.companyInfo.details as detail, i}
						<p class={i === footerData.companyInfo.details.length - 1 ? '' : 'mb-0'}>
							{detail}
						</p>
					{/each}
				</div>
			</div>

			{#each footerData.sections as section, idx}
				<!-- Column: {section.title} -->
				<div class="shrink-0 text-white">
					<p
						class="font-barlow text-xl font-semibold leading-[1.4]"
						style={idx === 0 ? 'width: 15.625rem;' : 'width: 14.625rem;'}
					>
						{section.title}
					</p>
					<div
						class="mt-[0.8125rem] font-barlow text-h6_light capitalize text-white"
						style="line-height: 2.322;"
					>
						{#each section.links as link, i}
							{#if link.href !== '#'}
								<a
									href={link.href}
									target={link.target || '_self'}
									class={i === section.links.length - 1 ? '' : 'block mb-0 hover:text-white/80'}
									>{link.text}</a
								>
							{:else}
								<p class={i === section.links.length - 1 ? '' : 'mb-0'}>{link.text}</p>
							{/if}
						{/each}
					</div>
				</div>

				{#if idx < footerData.sections.length - 1}
					<!-- Vertical Divider -->
					<div class="self-stretch w-px bg-[#38485f] shrink-0"></div>
				{/if}
			{/each}
		</div>

		<!-- Mobile: Stacked layout -->
		<div class="flex flex-col gap-8 pt-padding_xxlg lg:hidden">
			{#each footerData.sections as section}
				<!-- {section.title} -->
				<div class="text-white">
					<p class="font-barlow text-xl font-semibold leading-[1.4]">{section.title}</p>
					<div
						class="mt-[0.8125rem] font-barlow text-h6_light capitalize text-white"
						style="line-height: 2.322;"
					>
						{#each section.links as link, i}
							{#if link.href !== '#'}
								<a
									href={link.href}
									target={link.target || '_self'}
									class={i === section.links.length - 1 ? '' : 'block mb-0 hover:text-white/80'}
									>{link.text}</a
								>
							{:else}
								<p class={i === section.links.length - 1 ? '' : 'mb-0'}>{link.text}</p>
							{/if}
						{/each}
					</div>
				</div>

				<!-- Divider -->
				<div class="h-px w-full bg-[#38485f]"></div>
			{/each}

			<!-- Company Info -->
			<div class="text-white">
				<p class="font-barlow text-xl font-semibold leading-[1.4]">
					{footerData.companyInfo.title}
				</p>
				<div
					class="mt-[0.8125rem] font-barlow text-h6_light capitalize text-white"
					style="line-height: 2.322;"
				>
					{#each footerData.companyInfo.details as detail, i}
						<p class={i === footerData.companyInfo.details.length - 1 ? '' : 'mb-0'}>
							{detail}
						</p>
					{/each}
				</div>
			</div>

			<!-- Divider -->
			<div class="h-px w-full bg-[#38485f]"></div>
		</div>

		<!-- Desktop Bottom Divider -->
		<div class="hidden lg:block h-px w-full bg-[#38485f]"></div>

		<!-- Bottom Disclaimer -->
		<div class="pt-padding_lg pb-padding_xsm lg:py-padding_xxlg">
			<p class="font-barlow body_small leading-[1.737] text-white lg:text-h6_light">
				{footerData.disclaimer}
			</p>
		</div>
	</div>
</footer>
